import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";

const aOTContent = [
    {
        format: bodyHelperTypes.paragraphs,
        order: 10,
        content: [

            <>Assisted Outpatient Treatment (AOT), also known as Tim's Law, is a court-ordered program designed to ensure that individuals with serious mental illness (SMI) receive continuous treatment while living in the community. With regular court oversight and enhanced outpatient support, AOT helps individuals stay engaged in their treatment and succeed in their communities. The program aims to prevent gaps in care, reduce the risk of hospitalization or incarceration, enhance overall well-being, improve engagement in treatment and medication adherence, and support recovery and community independence in the least restrictive setting.</>,
            <>
                In 2017, the General Assembly passed Kentucky's first Assisted Outpatient Treatment (AOT) statute. Tim's Law, was named in memory of Tim Morton, a Lexington man with schizophrenia who was unable to acknowledge his own diagnosis and illness. During his lifetime, he was committed to inpatient treatment dozens of times, resisted attempts at outpatient treatment, and ultimately died in 2014 at age 56 from neglected health problems. Thanks to the efforts of his parents, advocacy groups, mental health agencies, and many others, Kentucky took a significant step toward stopping "the revolving door of jails, hospitals and homelessness with little benefit for such individuals" (Courier-Journal, 6/24/2016)
            </>,
            <>
                In July 2020, the KY Department of Behavioral Health, Developmental and Intellectual Disabilities (DBHDID) received a federal SAMHSA grant to fund a pilot project for Kentucky's 192 Assisted Outpatient Treatment (AOT) cases. The project coordinated the efforts of Community Mental Health Centers and state psychiatric hospitals in submitting Tim's Law petitions and delivering community-based treatment to individuals under court order. The project has enabled AOT programs to operate in the region served by Central State Hospital (CSH) and Western State Hospital (WSH).
            </>,
            <>
                AOT was further expanded to the Eastern State Hospital (ESH) and Appalachian Regional Hospital (ARH) regions in starting in 2022 with state general funds appropriated to DBHDID by the Kentucky General Assembly.
            </>,
            <>
                With the addition of state general funds, ongoing development of the statewide AOT program resources to assist individuals referred to AOT from any petitioner source, including concerned family and community members, local behavioral health providers, physicians, law enforcement, and psychiatric hospitals. Key components of the AOT program include court involvement, comprehensive treatment, case management, and family/community support. As of mid-2025, AOT programs are operational in 21 counties, serving one-half of the state's overall population. Additional counties will be adding AOT programs in the coming months. 

            </>,
            <>
                The University of Kentucky's College of Social Work continues to work with DBHDID on evaluation efforts as part of a more extensive national review of AOT effectiveness.
            </>




        ],
    }











];

export default aOTContent;